import { WorkerControls } from "./WorkerControls";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { AgentHeader, AgentFacts, AgentActivity, AgentConnections, AgentCommands, AgentRemoval } from "./AgentDetailSections";

export function AgentDetails({ agent, onClose, onCompany, onInspect, onDelete, onChanged }) {
  return <Sheet open={!!agent} onOpenChange={(open) => { if (!open) onClose(); }}>
    <SheetContent className="brain-details-sheet" closeTestId="agent-details-close" data-testid="agent-details-panel">
      {agent && <>
        <AgentHeader agent={agent} />
        {agent.id !== "JARVIS" && <WorkerControls agentId={agent.id} agentName={agent.name} prefix="map-worker" onChanged={onChanged} />}
        <AgentFacts agent={agent} onClose={onClose} onCompany={onCompany} />
        <AgentActivity agent={agent} />
        <AgentConnections agent={agent} onInspect={onInspect} />
        <AgentCommands commands={agent.commands} />
        {agent.id !== "JARVIS" && <AgentRemoval agent={agent} onDelete={onDelete} />}
      </>}
    </SheetContent>
  </Sheet>;
}
